import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  buttonContainer: theme => ({
    height: 117.5,
    borderTopColor: theme.colors.horizontalLineColor,
    borderTopWidth: 1,
    justifyContent: 'center',
    marginHorizontal: 16,
  }),
  disabledButtonStyle: theme => ({
    backgroundColor: theme.colors.buttons.disabled,
  }),
  disabledTextStyle: theme => ({
    color: theme.colors.textButtons.disabled,
  }),
});
